import { useState } from "react";
import LawyerContainer from "./Lawyer/LawyerContainer";
import FormList from "./formList/formList";

const DsMainPage: React.FC = () => {
    const [LSUCID, setLSUCID] = useState<string>("");
    const [subscribed, setSubscribed] = useState<boolean>(false);
    const [loaded, setLoaded] = useState(false);
    
    return (
        <>
            <LawyerContainer
                LSUCID={LSUCID}
                setLSUCID={setLSUCID}
                setSubscribed={setSubscribed}
                setLoaded={setLoaded}
            />
            <FormList
                LSUCID={LSUCID}
                subscribed={subscribed}
                loaded={loaded}
            />
        </>
    )
}

export default DsMainPage;